import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import cx from 'clsx'

import Navigation from './components/Navigation'
import Skeleton from '../Skeleton'
import { useIsIos } from '@/utils/hooks/useIsMobileDevice'

export interface LayoutProps {}
const LayoutWrapper = () => {
  const isIos = useIsIos()
  return (
    <main className="h-full max-w-full">
      <section
        className={cx('flex h-[calc(100%-48px)] w-full flex-col gap-3 overflow-auto', { 'h-[calc(100%-70px)]': isIos })}
      >
        <Suspense fallback={<Skeleton isActive className="h-full w-full" />}>
          <Outlet />
        </Suspense>
      </section>
      <Navigation />
    </main>
  )
}

export default LayoutWrapper
